export default __webpack_public_path__ + "static/media/HDTX_LKTT 2025.96a4d826.pdf";